<div class="main_content">

  <div class="first_text">
    <p>Complete the authorization process. Please do not close the dialog until the process is complete.</p>
  </div>

  <div class="add_to_sheet">
    <button *ngIf="!(isLoading$ | async)"
            (click)="login()">
      <span>LOG IN</span>
    </button>
  </div>

  <div class="loader"
       *ngIf="isLoading$ | async">
    <span class="loader-icon"></span>
    <span class="loader-text">Logging in</span>
  </div>

  <div class="error"
       *ngIf="error">
    <span>Error: {{error}}</span>
  </div>

</div>
